import {emailHistoryRequestError,EmailHistoryReadError} from "./historyContract";

/** Two authentication adapters share this bounded, GET-only JSON transport. */
export async function readEmailHistoryJson(url:string,init:Pick<RequestInit,"headers"|"credentials">={},signal?:AbortSignal):Promise<unknown> {
  const controller=new AbortController();
  const abort=()=>controller.abort();
  if(signal?.aborted)throw new DOMException("Cancelled","AbortError");
  signal?.addEventListener("abort",abort,{once:true});
  const timeout=window.setTimeout(abort,30000);
  try {
    const response=await fetch(url,{...init,method:"GET",headers:new Headers(init.headers),signal:controller.signal});
    const payload=await response.json().catch(()=>null);
    if(!response.ok || payload?.success===false)throw emailHistoryRequestError(response.ok?400:response.status,payload?.error?.code);
    if(!payload || typeof payload!=="object" || !payload.data)throw emailHistoryRequestError(503);
    return payload.data;
  } catch(error) {
    if(signal?.aborted)throw new DOMException("Cancelled","AbortError");
    if(error instanceof EmailHistoryReadError)throw error;
    throw emailHistoryRequestError(503);
  } finally {window.clearTimeout(timeout);signal?.removeEventListener("abort",abort);}
}
